import React, { Fragment } from 'react';

import ReactPaginate from 'react-paginate';

import ChevronLeftIcon from 'Assets/icons/chevron-left.svg';
import ChevronRightIcon from 'Assets/icons/chevron-right.svg';

function TablePagination(props) {
    const showPerPage = props.showPerPage ?? false;
    const perPageOptions = props.perPageOptions ?? [10, 20, 50, 100];

    return (
        <Fragment>
            <ReactPaginate
                previousLabel={<ChevronLeftIcon className="tw-h-2 tw-w-1" />}
                nextLabel={<ChevronRightIcon className="tw-h-2 tw-w-1" />}
                pageCount={props.lastPage}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={props.pageChange}
                forcePage={props.currentPage ? props.currentPage - 1 : undefined}
                containerClassName="tw-flex tw-items-center tw-space-x-4"
                pageClassName="tw-inline-flex"
                previousLinkClassName="!tw-p-0"
                nextLinkClassName="!tw-p-0"
                disabledClassName="tw-opacity-40"
                disabledLinkClassName="tw-cursor-default"
                pageLinkClassName="tw-px-2 tw-py-1 tw-rounded hover:tw-bg-gray-100 hover:tw-text-inherit"
                activeClassName="tw-bg-blue-600 tw-rounded hover:tw-bg-transparent"
                activeLinkClassName="tw-text-white tw-px-2 tw-py-1"
                breakLabel="…"
                breakClassName="tw-px-2"
            />
            {!!showPerPage && (
                <div className="tw-flex tw-items-baseline tw-space-x-2">
                    <label htmlFor="perPage" className="tw-text-xs">
                        {$t('Items per page')}:
                    </label>
                    <select
                        id="perPage"
                        className="tw-border tw-rounded tw-px-2 tw-text-xs"
                        value={props.perPage}
                        onChange={(e) => props.onPerPageChange && props.onPerPageChange(Number(e.target.value))}
                    >
                        {perPageOptions.map((opt) => (
                            <option key={opt} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </Fragment>
    );
}

export default TablePagination;
